export default __webpack_public_path__ + "img/sabira_ios.93daff83.png";